import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    mainWrapper: {
        color: theme.colors.black,
        maxWidth: '100%',
        height: '100%',
    },

    mediaController:{
        width: '100%',
        height: '100%',
        aspectRatio: "16/9",
    },

    mediaControlBar: {
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        gap: 6,
        padding: '8px 6px',
        '& media-time-display': {
            flex: '0 1 auto',
            whiteSpace: 'nowrap',
        },
        '& media-volume-range': {
            flex: '1 1 96px',
            minWidth: 26,
            maxWidth: 120,
        },
    },

    primaryControlButton: {
        flex: '1 0 auto',
        '--media-control-height': '40px',
        '--media-button-icon-width': '22px',
        '--media-button-icon-height': '22px',
    },

    timelineControl: {
        flex: '1 1 auto',
        minWidth: 0,
    },

    videoContainer:{
        width: "100% !important",
        height: "100% !important",
    },

    [theme.down('tablet')]: {
        mediaControlBar: {
            gap: 6,
            padding: '6px 8px',
            '& media-time-display': {
                fontSize: 12,
            },
            '& media-mute-button': {
                '--media-control-height': '36px',
                '--media-button-icon-width': '18px',
                '--media-button-icon-height': '18px',
            },
            '& media-volume-range': {
                flex: '1 1 64px',
                minWidth: 48,
                maxWidth: 72,
            },
        },
        primaryControlButton: {
            '--media-control-height': '44px',
            '--media-button-icon-width': '24px',
            '--media-button-icon-height': '24px',
        },
    },
}));